
import { cache } from '@/utils/cacheManager'
import $store from '@/store'
import { searchConfig, searchConfigMap } from '@/api/user'

export class PricingAirConfigUtil {
  // 实例集合
  static instanceMap = new Map()
  constructor() {
    this._markupCfgValue = null
    this._needMarkup = parseInt(cache.config.get('PANeedMarkup')) === 1
    this._markupLocked = this._needMarkup && parseInt(cache.config.get('PALockMarkup')) === 1
    console.info('cache.config', cache.config)
    if (cache.config.get('PANeedMarkup')) {
      if (this._needMarkup) {
        if (this._markupLocked) {
          searchConfig({ officeId: $store.getters.currentOfficeId, configName: 'PAMarkupSetting' }).then((res) => {
            const entities = res.data
            for (const entity of entities) {
              if (!entity.hasOwnProperty('overrideable')) { // Config 才有这个字段
                this._markupCfgDef = entity
              } else {
                this._markupCfg = entity
                this.decodeMarkupSetting()
              }
            }
            this._isMarkupSettingsLoaded = true
          })
        }
      }
    }
    // 是否检查审核超时
    if (cache.config.has('PANeedCheckApprove')) {
      searchConfigMap({ officeId: $store.getters.currentOfficeId,
        configName: 'PANeedCheckApprove,PACheckApproveSetting' }).then((res) => {
        const map = res.data
        if (map != null) {
          this._needCheckApprove = map['PANeedCheckApprove'] === '1'
          if (this._needCheckApprove) {
            this._checkApproveSetting = map['PACheckApproveSetting']
          }
        }
        this._isCheckApproveSettingsLoaded = true
      })
    }
  }

  static async getInstance() {
    const officeId = $store.getters.currentOfficeId
    let instance = this.instanceMap.get(officeId)
    if (!instance) {
      await cache.load('config')
      instance = new PricingAirConfigUtil()
      this.instanceMap.set(officeId, instance)
    }
    return instance
  }

  get needMarkup() {
    return this._needMarkup
  }

  set needMarkup(value) {
    this._needMarkup = value
  }

  get markupLocked() {
    return this._markupLocked
  }

  set markupLocked(value) {
    this._markupLocked = value
  }

  get isMarkupSettingsLoaded() {
    return this._isMarkupSettingsLoaded
  }

  set isMarkupSettingsLoaded(value) {
    this._isMarkupSettingsLoaded = value
  }

  get markupCfgDef() {
    return this._markupCfgDef
  }

  set markupCfgDef(value) {
    this._markupCfgDef = value
  }

  get markupCfg() {
    return this._markupCfg
  }

  set markupCfg(value) {
    this._markupCfg = value
  }

  decodeMarkupSetting() {
    if (this._markupCfg && this._markupCfg.value !== '') {
      this._markupCfgValue = JSON.parse(this._markupCfg.value)
    }
  }

  get markupCfgValue() {
    return this._markupCfgValue
  }

  set markupCfgValue(value) {
    this._markupCfgValue = value
  }

  get needCheckApprove() {
    return this._needCheckApprove
  }

  set needCheckApprove(value) {
    this._needCheckApprove = value
  }

  get checkApproveSetting() {
    return this._checkApproveSetting
  }

  set checkApproveSetting(value) {
    this._checkApproveSetting = value
  }

  get isCheckApproveSettingsLoaded() {
    return this._isCheckApproveSettingsLoaded
  }

  set isCheckApproveSettingsLoaded(value) {
    this._isCheckApproveSettingsLoaded = value
  }
}
